import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import TicketForm from "./Components/TicketForm";
import TicketList from "./Components/TicketList";

const API_URL = process.env.REACT_APP_API_URL

function Home() {
    const [activeTickets, setActiveTickets] = useState([]);
    const [inactiveTickets, setInactiveTickets] = useState([]);
    const [recentClosedTickets, setRecentClosedTickets] = useState([]);

    useEffect(() => {
        const fetchTickets = async () => {
            try {
                const url = `${API_URL}/get-tickets`
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error("Failed to fetch tickets");
                }
                const data = await response.json();

                // Get the current date and calculate the date 3 days ago
                const currentDate = new Date();
                const threeDaysAgo = new Date(currentDate);
                threeDaysAgo.setDate(currentDate.getDate() - 3);

                // Separate active and inactive tickets
                const active = data.filter(ticket => ticket.Estado === "Active");
                const inactive = data.filter(ticket => ticket.Estado === "Closed");

                // Filter the closed tickets that are not older than 3 days
                const recentClosed = inactive.filter(ticket => {
                    const ticketDate = new Date(ticket.TiempoEntrada);
                    return ticketDate >= threeDaysAgo;  // Compare with the 3-day limit
                });

                setActiveTickets(active);
                setInactiveTickets(inactive);
                setRecentClosedTickets(recentClosed);  // Set recent closed tickets
            } catch (error) {
                console.error("Error fetching tickets:", error);
            }
        };

        fetchTickets();
    }, []); // Runs once when the component mounts

    return (
        <div className="p-3 justify-content-center">
            <TicketForm />
            <div className="row">
                <div className="col-6 col-md-4">
                    <h3>Tickets Activos</h3>
                    <TicketList ticketList={activeTickets} />
                </div>
                <div className="col-6 col-md-4">
                    <h3>Tickets recientes cerrados</h3>
                    <TicketList ticketList={recentClosedTickets} />
                </div>
            </div>
        </div>
    );
}

export default Home;
